import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface ChainCommentDialogData {
  chainNumber: string;
  currentComment?: string;
}

export interface ChainCommentDialogResult {
  comment: string;
}

@Component({
  selector: 'app-chain-comment-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './chain-comment-dialog.component.html',
  styleUrl: './chain-comment-dialog.component.scss'
})
export class ChainCommentDialogComponent {
  comment: string = '';

  constructor(
    public dialogRef: MatDialogRef<ChainCommentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ChainCommentDialogData
  ) {
    this.comment = data.currentComment || '';
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSave(): void {
    this.dialogRef.close({ comment: this.comment.trim() });
  }
}
